import appLocaleData from 'react-intl/locale-data/pt';
import ptMessages from '../locales/pt_PT';

const PTLang = {
    messages: {
        ...ptMessages
    },
    locale: 'pt-PT',
    data: appLocaleData
};
export default PTLang;